import * as React from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import Snackbar from '@material-ui/core/Snackbar';

import { closeNotificationAction } from '../action/notifications/notifications';
import { notificationsSelector } from '../reducers/notification-selectors';

import { TransitionSlideUp } from './transition-slide-up';

type InputProps = {
  notifications: Array<TeamEngineNotification>;
};

const mapStateToProps = (state: any) => ({
  notifications: notificationsSelector(state),
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
  actions: {
    closeNotification: (key: string | number) => dispatch(closeNotificationAction(key)),
  },
});

type ReduxProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & ReduxProps & DispatchProps;

class SnackbarNotificationsComponent extends React.PureComponent<Props> {
  handleClose = (key: string | number) => () => {
    this.props.actions.closeNotification(key);
  };

  render() {
    const { notifications } = this.props;
    return (
      <>
        {notifications.map((n) => (
          <Snackbar
            className={n.className}
            key={`notification-${n.key}`}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            open={n.open}
            autoHideDuration={n.autoHideDuration ?? 5000}
            onClose={this.handleClose(n.key)}
            message={n.message}
            action={n.action}
            transitionDuration={{
              enter: 500,
              exit: 500,
            }}
            TransitionComponent={TransitionSlideUp}
          >
            {n.content && <div>{n.content(this.handleClose(n.key))}</div>}
          </Snackbar>
        ))}
      </>
    );
  }
}

export const SnackbarNotifications = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SnackbarNotificationsComponent);
